import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Label as Label$1 } from "@radix-ui/react-form";
import styles from "./form.module.css.js";
import classNames from "classnames";
const Label = forwardRef(function Label2({ children, ...props }, ref) {
  const classes = classNames(styles.label, props.className);
  return /* @__PURE__ */ jsx(Label$1, { ref, ...props, className: classes, children });
});
export {
  Label
};
//# sourceMappingURL=Label.js.map
